import { useNamespace, useTranslation } from '@splitfiesta/i18n';

import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function PrivacyPage() {
  const { t } = useTranslation();
  const pagesLoaded = useNamespace('pages');

  if (!pagesLoaded) {
    return null;
  }

  return (
    <StaticPageLayout
      title={t('pages:privacy.title')}
      subtitle={t('pages:privacy.subtitle')}
    >
      <div className="prose prose-gray dark:prose-invert max-w-none">
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          {t('pages:privacy.lastUpdated')}: {t('pages:privacy.lastUpdatedDate')}
        </p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.dataCollection.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:privacy.sections.dataCollection.description')}
          </p>
          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:privacy.sections.dataCollection.items.account')}</li>
            <li>{t('pages:privacy.sections.dataCollection.items.expenses')}</li>
            <li>{t('pages:privacy.sections.dataCollection.items.usage')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.dataUsage.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:privacy.sections.dataUsage.description')}
          </p>
          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:privacy.sections.dataUsage.items.service')}</li>
            <li>{t('pages:privacy.sections.dataUsage.items.improvements')}</li>
            <li>{t('pages:privacy.sections.dataUsage.items.communication')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.dataSharing.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:privacy.sections.dataSharing.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.aiFeatures.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:privacy.sections.aiFeatures.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.receiptScan.title')}
          </h2>

          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:privacy.sections.receiptScan.description')}
          </p>

          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:privacy.sections.receiptScan.items.stored')}</li>

            <li>{t('pages:privacy.sections.receiptScan.items.drafts')}</li>

            <li>{t('pages:privacy.sections.receiptScan.items.delete')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.voice.title')}
          </h2>

          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:privacy.sections.voice.description')}
          </p>

          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:privacy.sections.voice.items.audio')}</li>

            <li>{t('pages:privacy.sections.voice.items.text')}</li>

            <li>{t('pages:privacy.sections.voice.items.fallback')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.security.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:privacy.sections.security.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.rights.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:privacy.sections.rights.description')}
          </p>
          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:privacy.sections.rights.items.access')}</li>
            <li>{t('pages:privacy.sections.rights.items.correction')}</li>
            <li>{t('pages:privacy.sections.rights.items.deletion')}</li>
            <li>{t('pages:privacy.sections.rights.items.export')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:privacy.sections.contact.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:privacy.sections.contact.description')}{' '}
            <a
              href="mailto:hello@splitfiesta.com"
              className="text-orange-600 dark:text-orange-400 hover:underline"
            >
              hello@splitfiesta.com
            </a>
          </p>
        </section>
      </div>
    </StaticPageLayout>
  );
}

export default PrivacyPage;
